import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err.config?.url || "";
    const isAuthCall = url.includes("/auth/login") || url.includes("/auth/register");
    if (err.response?.status === 401 && !isAuthCall) {
      const detail = err.response?.data?.detail || "";
      let reason = "";
      if (detail.includes("altro dispositivo")) reason = "session_replaced";
      else if (detail.includes("Account scaduto")) reason = "expired";
      localStorage.removeItem("token");
      // Mai reindirizzare via dalle pagine di ritorno pagamento (devono funzionare anche senza sessione)
      const onPaymentPage = window.location.pathname.startsWith("/payment/");
      if (!window.location.pathname.startsWith("/login") && !onPaymentPage) {
        window.location.href = reason ? `/login?reason=${reason}` : "/login";
      }
    }
    // Paywall: contenuto riservato agli utenti con accesso completo
    if (err.response?.status === 402 && !window.location.pathname.startsWith("/sblocca")) {
      window.location.href = "/sblocca";
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e, fallback = "Qualcosa è andato storto. Riprova.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg;
  return fallback;
};
